import { axios } from "../config/axios";
import { IAxiosResponse } from "../interfaces/IAxiosResponse";
import { IPagination } from "../interfaces/IPagination";
import {
  ICreditActivityReport,
  ICreditLiabilityReport,
  IIssueCreditsRequest,
  IReservationPaymentBreakdown,
  IRevokeCreditsRequest,
  IWalletDetail,
  IWalletLedgerEntry,
  IWalletSummary
} from "../interfaces/wallet/Wallet.types";
import { serialize } from "../utils/serializeToQueryString";

// Paged like the ledger below, same parameter names: the search endpoint returns a PagedResponse, so the
// list screen can page through every wallet instead of showing the first hundred and hoping.
export const searchWallets = async (params: {
  email?: string;
  pageNumber?: number;
  pageSize?: number;
}): Promise<IAxiosResponse<IPagination<IWalletSummary>>> =>
  axios.get(`Wallet/Search${serialize(params)}`);

export const getWalletDetail = async (params: {
  walletId: number;
}): Promise<IAxiosResponse<IWalletDetail>> =>
  axios.get(`Wallet/${params.walletId}`);

export const getWalletLedger = async (params: {
  walletId: number;
  pageNumber?: number;
  pageSize?: number;
  type?: string;
}): Promise<IAxiosResponse<IPagination<IWalletLedgerEntry>>> => {
  const { walletId, ...query } = params;
  return axios.get(`Wallet/${walletId}/Ledger${serialize(query)}`);
};

export const issueCredits = async (
  data: IIssueCreditsRequest
): Promise<IAxiosResponse<IWalletLedgerEntry>> =>
  axios.post("Wallet/Issue", data);

export const revokeCredits = async (
  data: IRevokeCreditsRequest
): Promise<IAxiosResponse<IWalletLedgerEntry>> =>
  axios.post("Wallet/Revoke", data);

// How a booking was paid for — the daily-use view for support.
export const getReservationPayment = async (params: {
  uniqueJourneyId: string;
}): Promise<IAxiosResponse<IReservationPaymentBreakdown>> =>
  axios.get(`Wallet/Reservation/${params.uniqueJourneyId}`);

export const getCreditLiability = async (): Promise<
  IAxiosResponse<ICreditLiabilityReport>
> => axios.get("Wallet/Report/Liability");

export const getCreditActivity = async (params: {
  from?: string;
  to?: string;
  scope?: string;
}): Promise<IAxiosResponse<ICreditActivityReport>> =>
  axios.get(`Wallet/Report/Activity${serialize(params)}`);
